import sliceCreator from '../../index.js';
import {DELETE_RAW_MATERIAL} from '../../../constants/index.js';
const _deleteRawMaterialAction = sliceCreator('DELETE_RAW_MATERIAL', DELETE_RAW_MATERIAL, 'delete');

const { asyncAction: deleteRawMaterialAction, reducer, clearData: clearDeleteRawMaterialAction } = _deleteRawMaterialAction;

export default reducer;

export {
    deleteRawMaterialAction,
    clearDeleteRawMaterialAction
}